import { WifiOff, Wifi } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/use-online-status'
import { useEffect, useState } from 'react'

export function OfflineIndicator() {
  const isOnline = useOnlineStatus()
  const [showBackOnline, setShowBackOnline] = useState(false)
  const [wasOffline, setWasOffline] = useState(false)

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true)
    } else if (wasOffline) {
      setShowBackOnline(true)
      const timer = setTimeout(() => {
        setShowBackOnline(false)
        setWasOffline(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [isOnline, wasOffline])

  if (isOnline && !showBackOnline) {
    return null
  }

  if (showBackOnline) {
    return (
      <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 mobile-fade-in">
        <Wifi className="h-4 w-4" />
        <span className="text-sm font-medium">Back online</span>
      </div>
    )
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-orange-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 mobile-fade-in">
      <WifiOff className="h-4 w-4" />
      <span className="text-sm font-medium">You're offline</span>
    </div>
  )
}